import React from 'react';
import SvgIcon from './SvgIcon';

const CrimeManThief = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M18 8.5a6 6 0 10-12 0v2a6 6 0 1012 0v-2zM23 23.5v-1.106a1.979 1.979 0 00-.77-1.58A14.775 14.775 0 0015 18.178M9 18.178a14.775 14.775 0 00-7.23 2.636 1.98 1.98 0 00-.77 1.58V23.5"
            stroke="currentColor"
            strokeWidth={0.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 15.7v2.8a6.34 6.34 0 003 1 6.34 6.34 0 003-1v-2.8M11 19.369v-2.952M13 19.369v-2.952M14 13.5c0 .552-.895 1-2 1s-2-.448-2-1a2.083 2.083 0 014 0zM11 8.5A1.56 1.56 0 019.5 10 1.6 1.6 0 018 8.5a1.035 1.035 0 011-1c1 0 2 .448 2 1zM13 8.5a1.56 1.56 0 001.5 1.5A1.6 1.6 0 0016 8.5a1.035 1.035 0 00-1-1c-1 0-2 .448-2 1zM13.416.5a.492.492 0 01.486.62 2 2 0 01-3.8 0 .493.493 0 01.482-.62h2.832z"
            stroke="currentColor"
            strokeWidth={0.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

CrimeManThief.displayName = 'CrimeManThiefIcon';

export default CrimeManThief;
